import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/BigBox_Divertir.jpg'
import _imports_1 from '@/assets/img/Billboard_Divertir.jpg'


const _hoisted_1 = { class: "Babillard" }
const _hoisted_2 = { class: "Babillard_Container section" }
const _hoisted_3 = { class: "typo_block-title U--mb--0" }
const _hoisted_4 = { class: "U--text-align-right" }
const _hoisted_5 = { class: "promo U--mb--0" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import translations from '@/dictionaries/homepage.json';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import BabillardListComponent from './BabillardListComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BabillardComponent',
  setup(__props) {

const isVisible = ref(true);

const setPosition = () => {
  if (window.innerWidth >= 992) {
    isVisible.value = true;
  } else {
    isVisible.value = false;
  }
};

onMounted(() => {
  setPosition();
  window.addEventListener('resize', setPosition);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosition);
});


return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_container, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_row, { class: "Babillard_ContainerTitle text-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(translations).babillard.fr.title), 1)
                ]),
                _: 1
              }),
              (isVisible.value)
                ? (_openBlock(), _createBlock(_component_b_col, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translations).babillard.fr.promo), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                lg: "8",
                class: "Babillard_ContainerList"
              }, {
                default: _withCtx(() => [
                  _createVNode(BabillardListComponent, {
                    translation: _unref(translations).babillard.fr.errorMessage
                  }, null, 8, ["translation"])
                ]),
                _: 1
              }),
              (isVisible.value)
                ? (_openBlock(), _createBlock(_component_b_col, {
                    key: 0,
                    cols: "12",
                    lg: "4",
                    class: "Babillard_ContainerImage"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: _unref(translations).babillard.fr.pubUrl2,
                        target: "_blank"
                      }, _cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _imports_0
                        }, null, -1)
                      ]), 8, _hoisted_6)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_b_row, { class: "Babillard_ContainerPromo" }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(translations).babillard.fr.pubUrl,
                target: "_blank"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("img", { src: _imports_1 }, null, -1)
              ]), 8, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})